/*
API ABSTRACTION

Schema is an object, in the form we need
api is the response from the webservice
this function format the response following the schema

The simple convention is
- a schema should be flat, without deep nested values (only for sake of convenience to treat data in front end)
- if the value of the key is a string, it s a path in the api response to find the data
- if the value is a function, the function accept as one and only argument the complete response of the api

ex:
const apiresponse = {
  data: {
    city: {
      name: 'foo',
      lat: 123,
      lon: 456,
      stations: [
        { name: 'bar'},
        { name: 'baz'}
      ]
    }
  }
}

Our schema expected by your model is:
const schema = {
  name: 'data.city.name',
  lnglat: (data) => [data.city.lon, data.city.lat],
  firstStationName: 'data.city.stations.0.name'
}

console.log(JSON.stringiy(format(schema, apiresponse), null, 2))
outputs: {
  name: 'foo',
  lnglat: [456, 123],
  firstStationName: 'bar'
}

*/
export const format = (sch, api) => {
  return Object.keys(sch).reduce((res, k) => {
    const apiKey = sch[k]
    const type = typeof (apiKey)
    if (type === 'function') {
      res[k] = apiKey(api)
    } else if (apiKey.includes('.')) {
      const path = apiKey.split('.')
      let val = Object.assign({}, api)
      for (let key of path) {
        if (isNaN(key)) val = val[key]
        else val = val[Number(key)]
      }
      res[k] = val
    } else {
      res[k] = api[apiKey]
    }
    return res
  }, {})
}
